import Api from "./ApiService";

export default class Validator {


    StringLength = (min, max, target) => {
        if (typeof (target) === 'string') {
            if (target.length >= min) {
                if (target.length < max) {
                    return true;
                }
            }
        }
        return false;
    }

    IsNumeric = (target) => {
        let numberRegex = new RegExp(/^\d+$/, "gm");
        return numberRegex.test(target);
    }

    IsZaehlerstand = (target) => {
        return /^-?\d+([.,]\d{1,3})?$/.test(target);
    }

    EmailValid = (target) => {
        let emailRegex =
        new RegExp("^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Za-z0-9.-]+$", "gm");
        if (typeof (target) == "string") {
            if (target.length > 4) {
                if (emailRegex.test(target)) {
                    return true;
                }
            }
        }
        return false;
    }

    EmailExists = async (email) => {
        let API = new Api();
        await API.email_exists(email)
            .then((res) => {
                let data = res.data;
                return data;
            })
    }


    PhoneValid = (target) => {
        let phoneRegex = new RegExp(/^[+]\d{1,4}[-\s]{1}(\d{1,4}[-\s]{0,1})+$/, "gm");
        return phoneRegex.test(target);
    }



    PasswordValid = (target) => {
        let passRegex = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)[\w\W]{10,}$/, "gm");
        if (target.length >= 8 && target.length < 50) {
            if (passRegex.test(target)) {
                return true;
            } else return false;
        } else return false;
    }


    PasswordsEquals = (pass1, pass2) => {
        if (pass1 === pass2 && pass1.length > 6) return true;
        else return false;
    }


    isDictEmpty = (dict) => {
        return Object.keys(dict).length === 0;
    }


    ibanValid = (iban) => {
        let ibanRegex = new RegExp(/^(?:((?:IT|SM)\d{2}[A-Z]{1}\d{22})|(NL\d{2}[A-Z]{4}\d{10})|(LV\d{2}[A-Z]{4}\d{13})|((?:BG|GB|IE)\d{2}[A-Z]{4}\d{14})|(GI\d{2}[A-Z]{4}\d{15})|(RO\d{2}[A-Z]{4}\d{16})|(MT\d{2}[A-Z]{4}\d{23})|(NO\d{13})|((?:DK|FI)\d{16})|((?:SI)\d{17})|((?:AT|EE|LU|LT)\d{18})|((?:HR|LI|CH)\d{19})|((?:DE|VA)\d{20})|((?:AD|CZ|ES|MD|SK|SE)\d{22})|(PT\d{23})|((?:IS)\d{24})|((?:BE)\d{14})|((?:FR|MC|GR)\d{25})|((?:PL|HU|CY)\d{26}))$/, "gm");
        if (ibanRegex.test(iban)) return true
        return false;
    }

    formatedIbanValid = (iban) => {
        let formated = iban.replace(/\s+/g, '');
        let ibanRegex = new RegExp(/^(?:((?:IT|SM)\d{2}[A-Z]{1}\d{22})|(NL\d{2}[A-Z]{4}\d{10})|(LV\d{2}[A-Z]{4}\d{13})|((?:BG|GB|IE)\d{2}[A-Z]{4}\d{14})|(GI\d{2}[A-Z]{4}\d{15})|(RO\d{2}[A-Z]{4}\d{16})|(MT\d{2}[A-Z]{4}\d{23})|(NO\d{13})|((?:DK|FI)\d{16})|((?:SI)\d{17})|((?:AT|EE|LU|LT)\d{18})|((?:HR|LI|CH)\d{19})|((?:DE|VA)\d{20})|((?:AD|CZ|ES|MD|SK|SE)\d{22})|(PT\d{23})|((?:IS)\d{24})|((?:BE)\d{14})|((?:FR|MC|GR)\d{25})|((?:PL|HU|CY)\d{26}))$/, "gm");
        if (ibanRegex.test(formated)) return true
        return false;
    }


    vatValid = (vat) => {
        let vatRegex = new RegExp(/^(ATU[0-9]{8}|BE[01][0-9]{9}|BG[0-9]{9,10}|HR[0-9]{11}|CY[A-Z0-9]{9}|CZ[0-9]{8,10}|DK[0-9]{8}|EE[0-9]{9}|FI[0-9]{8}|FR[0-9A-Z]{2}[0-9]{9}|DE[0-9]{9}|EL[0-9]{9}|HU[0-9]{8}|IE([0-9]{7}[A-Z]{1,2}|[0-9][A-Z][0-9]{5}[A-Z])|IT[0-9]{11}|LV[0-9]{11}|LT([0-9]{9}|[0-9]{12})|LU[0-9]{8}|MT[0-9]{8}|NL[0-9]{9}B[0-9]{2}|PL[0-9]{10}|PT[0-9]{9}|RO[0-9]{2,10}|SK[0-9]{10}|SI[0-9]{8}|ES[A-Z]([0-9]{8}|[0-9]{7}[A-Z])|SE[0-9]{12}|GB([0-9]{9}|[0-9]{12}|GD[0-4][0-9]{2}|HA[5-9][0-9]{2}))$/, "gm");
        return vatRegex.test(vat);
    }

    checkVatOnline = async(vat) => {
        let api = new Api();
        try {
            let resp = await api.checkVat(vat);  // Wait for API response
            return resp.data.valid;  // Return the valid status
        } catch (error) {
            return false;  // Return false on error
        }
    }

    dateValid = (date) => {
        let dateRegex = new RegExp(/^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/, 'gm');
        return dateRegex.test(date);
    }

    zipValid = (zip, countryCode = "12") => {
        if (countryCode === "12" && zip !== "" && zip.length === 4) return true;
        if (countryCode === "57" && zip !== "" && zip.length === 5) return true;
        return false;
    }

    olderThan18 = (birthdate) => {
        const currentDate = new Date();
        const minDate = new Date(
            currentDate.getFullYear() - 18,
            currentDate.getMonth(),
            currentDate.getDate()
        );
        return new Date(birthdate) <= minDate;
    }


    isValidZip = (countryCode, region, zip) => {
        // meke sure passed data is strings
        countryCode = String(countryCode);
        region = String(region);
        zip = String(zip);

        if (zip === "") return false;
        if (isNaN(zip)) return false;
        if (zip.length !== 4 && countryCode === "12") return false;
        if (zip.length !== 5 && countryCode === "57") return false;
        if (countryCode !== "12") return true;
        if (zip[0] === "1" && (region === "1444" || region === "1438")) return true;
        if (zip[0] === "2" && (region === "1436" || region === "1438")) return true;
        if (zip[0] === "3" && (region === "1439" || region === "1438")) return true;
        if (zip[0] === "4" && (region === "1439" || region === "1438")) return true;
        if (zip[0] === "5" && (region === "1439" || region === "1440")) return true;
        if (zip[0] === "6" && (region === "1442" || region === "1443")) return true;
        if (zip[0] === "7" && region === "1436") return true;
        if (zip[0] === "8" && (region === "1441" || region === "1436")) return true;
        if (zip[0] === "9" && (region === "1442" || region === "1437")) return true;

        return false;
    }

    isValidZeahlpunk = (target) => {
        if (typeof target === 'string' && target.length === 33) {
            return true;
        }
        return false;
    }

    isValidEnergyForm = (target) => {
        if (
            target === "Strom" ||
            target === "Gas" || 
            target === "Strom-Einspeisung"
        ) return true
        return false;
    }


    isFormatedZaehlpunknummerValid = (target) => {
        var noSpace = target.replaceAll(" ", "");
        if (noSpace.length === 33) return true;
        return false;
    }

    isCountryIdValid = (country) => {
        country = parseInt(country);
        if (country !== NaN) {
            if (country === 12 || country === 57)
                return true;
        }
        return false;
    }

    isStateIdValid = (state) => {
        state = parseInt(state);
        var statesAllowed = [1436, 1437, 1438, 1439, 1440, 1441, 1442, 1443, 1444];
        if (state !== NaN) {
            if (statesAllowed.includes(state)) return true;
        }
        return false;
    }
}